import jwtDecode from 'jwt-decode';
import { ModifiedJwtPayload } from '../types/auth';

export const decodeToken = (token: string): ModifiedJwtPayload => jwtDecode(token);
